import type { Documentation, DocumentationType } from '../../common/types/documentation';

const filterDocumentationsByType = (documentations: Documentation[], type: DocumentationType): Documentation[] =>
  documentations.filter((documentation) => documentation.type === type);

const documentationHelpers = {
  filterDocumentationsByType,
};

export default documentationHelpers;
